import { protectedResources } from '../../authConfig';
import makeGetRequestAsync, {
  makePatchRequestAsync,
  makePostRequestAsync
} from '../Helpers/httpRequestHelpers';
import { BaseCompanyInfo } from './Models/BaseCompanyInfo';
import { CompanyDuplicateCheckResponse } from './Models/CompanyDuplicateCheckResponse';
import { CompanyRegistrationNumberModel } from './Models/CompanyRegistrationNumberModel';
import { CompanyViewModel } from './Models/CompanyViewModel';

const apiScopes = protectedResources.companyApi.scopes;
const baseUrl = protectedResources.companyApi.endpoint;

/*
 *  Retrieves all companies stored in the database.
 */

/*
 *  Retrieves all basic metadata
 */
export async function GetSomeBasicCompanyInfoAsync(searchTerm: string) {
  const url = `${baseUrl}/api/Company/GetSomeBasicCompanyInfoAsync/${searchTerm}`;
  return makeGetRequestAsync<BaseCompanyInfo[]>(apiScopes, url);
}

/*
 *  Retrieves a specific company based on a passed company ID
 */
export async function GetCompanyDataById(companyId: string | number, staged: boolean) {
  const url = `${baseUrl}/api/Company/CompanyWithAdminById/${companyId}/${staged}`;
  return makeGetRequestAsync<CompanyViewModel>(apiScopes, url);
}

/*
 *  Retrieves a specific company based on a passed user ID
 */

/*
 * Adds a new company record (only Company, not the associated metadata like contacts, addresses, etc.)
 */

/*
 *  Updates company data
 */

/*
 *  Updates company data
 */

/*
 *  Updates ENTIRE company data (including contacts, addresses, B-BBEE, bank accounts, and Products & Services);
 */
export async function SaveEntireCompany(company: CompanyViewModel, staged: boolean) {
  const url = `${baseUrl}/api/Company/UpdateEntireCompany/${staged}`;
  return makePatchRequestAsync(apiScopes, url, company);
}

/*
 * Updates ONLY a live company's website URL (bug #9039). Use this instead of SaveEntireCompany when
 * the screen edits nothing else: SaveEntireCompany re-sends and rewrites the whole company.
 * Pass null to clear the website.
 */
export async function UpdateCompanyWebsiteUrl(
  companyId: number,
  websiteUrl: string | null
) {
  const url = `${baseUrl}/api/Company/UpdateCompanyWebsiteUrl`;
  return makePatchRequestAsync(apiScopes, url, { companyId, websiteUrl });
}

/*
 * Fetch a user's default company ID.
 */

/*
 * Retrieves base company information with a user's AD ID.
 */

/*
 * Retrieves base company information with a company ID.
 */

export async function GetBaseCompanyInfoViaCompanyId(
  companyId: string | number,
  staged: boolean
) {
  const url = `${baseUrl}/api/Company/GetBaseCompanyInfoViaCompanyId/${companyId}/${staged}`;

  return (await makeGetRequestAsync<BaseCompanyInfo>(apiScopes, url)).data;
}

/*
 * Sends an invitation email to a new supplier
 */

/*
 * Remove my company from the platfrom
 */

/*
 * Retreive company profile completion summary
 */

export const checkDuplicateRegistrationNumber = async (
  company: CompanyRegistrationNumberModel
) => {
  const url = `${baseUrl}/api/Company/CompanyDuplicateCheckByRegistrationNumber`;
  const response = await makePostRequestAsync<
    CompanyDuplicateCheckResponse,
    CompanyRegistrationNumberModel
  >(apiScopes, url, company);
  return response.data;
};
